/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/*
 * SiteSpecificDigitalPassesSection.jsx
 * Created by Destin Frasier on 12/12/18
 */

import React from 'react';

import { ContentBlock, FlexRow, FlexCol, Heading } from 'sarsaparilla';

const defaultProps = {};
const propTypes = {};

export default class SiteSpecificDigitalPassesSection extends React.PureComponent {
    render() {
        return (
            <ContentBlock
                className="pass-site-specific-wrapper"
                id="site-specific-digital-passes"
            >
                <FlexRow>
                    <FlexCol className="pass-site-specific-section-header">
                        <Heading
                            headingLevel={2}
                            appearance="h4"
                            hasUnderline="left"
                            className="rec-section-heading-pass mb-2"
                        >
                            Site Passes
                        </Heading>
                        <p>
                            These digital passes cover entrance or standard amenity (day
                            use) fees at a single location. Destinations across the
                            country offer the convenience of digital passes, with a
                            variety of pass options at each individual location for daily,
                            weekly, seasonal, and/or annual access. Site Passes are also
                            available immediately for download and can be used from your
                            phone or tablet.
                        </p>
                    </FlexCol>
                </FlexRow>
            </ContentBlock>
        );
    }
}

SiteSpecificDigitalPassesSection.propTypes = propTypes;
SiteSpecificDigitalPassesSection.defaultProps = defaultProps;
